import React from "react";

function FormLineTitleMobile(props) {
  return (
    <div
      className={
        props.color === "1"
          ? "formLineTitleMobile2 light-grey-form"
          : "formLineTitleMobile2 grey-form"
      }
    >
      <div className="formLineBlockAll">{props.title}</div>
    </div>
  );
}

export default FormLineTitleMobile;
